export default "__VITE_ASSET__pI1sOE$s__"